import { Button, marginLeft, paddingLeft, themeGet } from '@pocketlaw/tetris';
import { breakpoint } from '@pocketlaw/tetris/deprecated';
import styled from 'styled-components';
const SPACING = 8;
export const CustomGrid = styled.div `
  display: flex;
  flex-flow: row wrap;

  @media ${breakpoint.desk} {
    ${marginLeft(-SPACING)}
  }
`;
export const Column = styled.div `
  width: 100%;
  box-sizing: border-box;

  @media ${breakpoint.desk} {
    ${paddingLeft(SPACING)};
    width: ${props => props.width};
  }
`;
export const CustomerDetailsContent = styled.div `
  & + & {
    margin-top: ${themeGet('spacing.md')};
  }
`;
export const CustomerDetailsTitle = styled.div `
  font-size: ${themeGet('fontSize.medium')};
  font-weight: ${themeGet('fontWeight.bold')};
`;
export const CustomerDetailsValue = styled.div `
  font-size: ${themeGet('fontSize.large')};
`;
export const CopyButton = styled(Button) `
  display: inline-flex;
`;
